import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import { get, isEmpty } from 'lodash'
import { formatPercentOneDecimal, formatThousand } from 'src/utils/functions'
import { NO_DATA_MESSAGE } from 'src/utils/constants'
import ScrollingTable, { dateRenderer } from '../Tables/ScrollingTable'
import AsOfDate from '../AsOfDate'

class TopHoldingsFixedIncome extends PureComponent {
  static columns = [
    {
      Header: 'Name',
      accessor: 'securityName',
      id: 'securityName',
    },
    {
      Header: 'Maturity Date',
      accessor: 'maturityDate',
      id: 'maturityDate',
      Cell: dateRenderer,
    },
    {
      Header: 'Coupon Rate (%)',
      accessor: 'couponRate',
      id: 'couponRate',
      Cell: (props) => (
        <span>{formatPercentOneDecimal(props.value / 100)}</span>
      ),
    },
    {
      Header: "Value ($000's)",
      accessor: 'marketValue',
      id: 'marketValue',
      Cell: (props) => <span>{formatThousand(props.value, 0)}</span>,
    },
    {
      Header: '% of Net Assets',
      accessor: 'weight',
      id: 'weight',
      Cell: (props) => {
        const value = isNaN(props.value) ? 0 : props.value
        return <span>{formatPercentOneDecimal(value)}</span>
      },
    },
  ]

  tableOptions = { presentation: this.props.presentation, stripedTable: true }

  getFooterData = (topHoldings) => [
    {
      securityName: '% of Total Holdings:',
      weight: `${topHoldings
        .reduce((total, item) => {
          const parsedWeight = parseFloat(item.weight)
          return (
            total +
            (isNaN(parsedWeight) ? 0 : Math.round(parsedWeight * 1000) / 10)
          )
        }, 0)
        .toFixed(1)}%`,
    },
  ]

  render() {
    const { data, presentation } = this.props
    const topHoldings =
      get(data, 'topHoldings') || get(data, 'dailyHoldings', []) || []
    const asofdate = get(topHoldings, '[0].calendar.date')
    const tableOptions = this.tableOptions
    const footerData = this.getFooterData(topHoldings)
    if (isEmpty(topHoldings)) {
      return <p>{NO_DATA_MESSAGE}</p>
    }

    return (
      <>
        <AsOfDate date={asofdate} />
        <ScrollingTable
          columns={TopHoldingsFixedIncome.columns}
          data={topHoldings}
          footerData={footerData}
          options={tableOptions}
        />
      </>
    )
  }
}

TopHoldingsFixedIncome.propTypes = {
  data: PropTypes.shape({
    topHoldings: PropTypes.array,
    dailyHoldings: PropTypes.array,
  }),
  presentation: PropTypes.object,
}

export default TopHoldingsFixedIncome
